// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostHeaderContent-moduleNewsboardPostHeaderUser__KUub0";
var _2 = "NewsboardPostHeaderContent-moduledisableLink__tVpFq";
var _3 = "NewsboardPostHeaderContent-moduleinfoContainer__uB3rU";
var _4 = "NewsboardPostHeaderContent-modulepinContainer__dJVx_";
var _5 = "NewsboardPostHeaderContent-modulestatusBlocked__K3GjO";
var _6 = "NewsboardPostHeaderContent-moduletextContainer__LfZmR";
var _7 = "NewsboardPostHeaderContent-moduleunreadBadge__XPfNC";
var _8 = "NewsboardPostHeaderContent-moduleuserContainer__haRcZ";
var _9 = "NewsboardPostHeaderContent-moduleuserName__MDlcL";
export { _1 as "NewsboardPostHeaderUser", _2 as "disableLink", _3 as "infoContainer", _4 as "pinContainer", _5 as "statusBlocked", _6 as "textContainer", _7 as "unreadBadge", _8 as "userContainer", _9 as "userName" }
